import React, { Component } from "react"
import PropTypes from "prop-types"
import MetaTags from 'react-meta-tags';
import { connect } from "react-redux"
import { Link, withRouter } from "react-router-dom"
import { withTranslation } from "react-i18next"
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { getBuilderDetail, addBuilderDepart, getProjectUUIDAction } from "../../../store/actions";
import ProjectList from "../../../components/VerticalLayout/ProjectList";
import performance_img from '../../../assets/img/performance.png'
import cost_pl_img from '../../../assets/img/cost_pl.png'
import {
  Col,
  Container,
  Row,
  Card,
  CardBody
} from "reactstrap"
import ProjectChart from "./detail-chart/project-chart";
import RsLink from "components/buttons/rsLink";
import axios from "axios";
import { API_URL } from "helpers/app_url";
import LeadPiechart from "./detail-chart/charts/leadChart";
import BudgetPiechart from "./detail-chart/charts/budgetChart";
import ProjectBarchart from "./detail-chart/charts/prbarChart";
import RSPieChart from "components/charts/RSPieChart";
class ProjectBuilderDetail extends Component {
  constructor(props) {
    super(props)
    this.state = {
      titles:[],
      departments:[],
      spents:[],
      
    }
  }
 
  componentDidMount() {
    const { match: { params }, onGetProjectUUIDAction} = this.props;
  
    onGetProjectUUIDAction(params.projectId)
    this.fetchAllounts();
    this.fetchLeadSourceData();
    this.fetchBudgetSourceData();

  }
 fetchAllounts = async () => {
    const obj = JSON.parse(localStorage.getItem("authUser"));
    const token = obj?.resultData?.bearerToken;
    const str = `Bearer ${token}`;

    try {
        const response = await axios.get(`${API_URL}Builder/getProjectBuilderDashboardByAgentQuery`, {
            params: {
                agentId: localStorage.getItem("userId"),
                builderId: this.props.match.params.id,
                projectId: this.props.match.params.projectId,
            },
            headers: { Authorization: str }
        });

        if (response.data && typeof response.data === "object") {
          this.setState({
              totalProspect: response.data.totalProspect || 0,
              totalWorksheet: response.data.totalWorksheet || 0,
              totalClient: response.data.totalClient || 0,
              costPerLead: response.data.costPerLead || 0,
              costPerClient: response.data.costPerClient || 0,
          });            
           
        }
    } catch (error) {
        console.error("Error fetching lead counts:", error);
    }
};
fetchLeadSourceData = async () => {
  const agentId = localStorage.getItem("userId");
  const builderId= this.props.match.params.id;
  const projectId = this.props.match.params.projectId;
  const obj = JSON.parse(localStorage.getItem("authUser"));
  const token = obj?.resultData?.bearerToken;
  const url = `${API_URL}Builder/GetProjectBuilderSourceDashboardByAgent?agentId=${agentId}&builderId=${builderId}&projectId=${projectId}`;

  try {
    const response = await axios.get(url, { headers: { Authorization: `Bearer ${token}` } });
      if (response.data && Array.isArray(response.data)) {
      
        const sources = response.data.map(item => item.sources);
        const counts = response.data.map(item => item.counts);
      this.setState({
        leadSourceData: {
          series: counts,
          options: {
            chart: { type: "pie" },
            labels: sources,
            colors: ["#66C2A5", "#FFD92F", "#A6D854", "#E78AC3"],
            legend: {
              show: true,
              position: "bottom",
              horizontalAlign: "center",
              verticalAlign: "middle",
              floating: false,
              fontSize: "14px",
              offsetX: 0,
              offsetY: -10,
            },
            responsive: [{ breakpoint: 600, options: { chart: { height: 440 }, legend: { show: false } } }],
          },
        },
      });
    }
  } catch (error) {
    this.setState({ error: error.message });
  }
};

fetchBudgetSourceData = async () => {
  const agentId = localStorage.getItem("userId");
  const builderId= this.props.match.params.id;
  const projectId = this.props.match.params.projectId;
  const obj = JSON.parse(localStorage.getItem("authUser"));
  const token = obj?.resultData?.bearerToken;
  const url = `${API_URL}Builder/getProjectBuilderBudgetDashboardByAgent?agentId=${agentId}&builderId=${builderId}&projectId=${projectId}`;

  try {
    const response = await axios.get(url, { headers: { Authorization: `Bearer ${token}` } });
      if (response.data && Array.isArray(response.data)) {
        this.setState({ spents: response.data });
        const sources = response.data.map(item => item.sources);
        const counts = response.data.map(item => item.counts1);
      this.setState({
        budgetData: {
          series: counts,
          options: {
            chart: { type: "pie" },
            labels: sources,
            colors: ["#66C2A5", "#FFD92F", "#A6D854", "#E78AC3"],
            legend: {
              show: true,
              position: "bottom",
              horizontalAlign: "center",
              verticalAlign: "middle",
              floating: false,
              fontSize: "14px",
              offsetX: 0,
              offsetY: -10,
            },
            responsive: [{ breakpoint: 600, options: { chart: { height: 440 }, legend: { show: false } } }],
          },
        },
      });
    }
  } catch (error) {
    this.setState({ error: error.message });
  }
};



  render() {
      const { projectData } =  this.props;
      const{ totalProspect, totalWorksheet, totalClient, costPerLead, costPerClient, spents } = this.state;
    return (
      <React.Fragment>
          {this.props.loading && this.props.loading ? (
                    <div className="loading">Loading&#8230;</div>
                ) : null}
         <ToastContainer autoClose={2000} />
        <div className="page-content project-page-content">
          <MetaTags>
            <title>Builder Detail | Realty Space</title>
          </MetaTags>
          <Container fluid className="ps-0 ">
            <Row>
            <Col sm='2' className="pe-0" >
                <ProjectList />
              </Col>  
              <Col sm='10' className="ps-0">
                <Row className="project-header">
                  <Col sm="6">
                  <h2 className="" style={{paddingTop:20, paddingBottom:20}}>{projectData.projectName}</h2>
                  </Col>

                  <Col sm="6">
                  <div className="pt-2 float-end mt-2">
                  <RsLink className="btn btn-light" iconClass="bx bx-link-external"  to={"/pre-construction/campaign/" + projectData.preConsProjectGuid }>View Project</RsLink>
                  </div>
                  </Col>
                </Row> 

                
                   
                   
                <Row>
                    <Col sm="4">
                    <h4 style={{textAlign:"center"}}>Lead sources</h4>
                             {this.state.leadSourceData && <RSPieChart title="" filter={false}  {...this.state.leadSourceData} />} 
                    
                    </Col>
                    <Col sm="4">
                    <h4 style={{textAlign:"center"}}>Budget distribution</h4>
                    {this.state.budgetData && <RSPieChart title="" filter={false}  {...this.state.budgetData} />} 
                   
                    </Col>
                    <Col sm="4">
                    <h4 style={{textAlign:"center"}}>Client generation</h4>
                    
                           <ProjectBarchart builderId={this.props.match.params.id} projectId={this.props.match.params.projectId} />
                   
                    </Col>
                </Row>
                
                <Row style={{marginTop:40}}>
           
           
           <Col md="6">
             <Card className="mini-stats-wid" style={{borderBottom:0}}>
                     <CardBody>
                       <div className="d-flex">
                         <div className="flex-grow-1">
                           <h4 className="">
                               Marketing 
                           </h4>
                           {spents.map((spent, index) => (
                             <h5 key={index} className="mb-0">{spent.sources} : ${spent.counts1}</h5>
                            ))}
                          
                          
                         </div>
                         <div className="align-self-center">
                           <img src={performance_img} alt="performance PNG" width='50px'/>
                         </div>
                        
                       </div>
                     </CardBody>
                   </Card>
             
           </Col>
           <Col md="6" >
             <Card className="mini-stats-wid" style={{borderBottom:0}}>
                     <CardBody>
                       <div className="d-flex">
                         <div className="flex-grow-1">
                         <h4 className="">
                           Cost per lead
                           </h4>
                           <h5 className="mb-0">#Lead : {totalProspect}<br/>
                              <small>Cost per lead  {costPerLead}</small>
                           </h5>
                           <h5 className="" style={{marginBottom:10, marginTop:10}}>#Worksheet : {totalWorksheet}<br/>
                             
                           </h5>
                           <h5 className="mb-0">#Clients : {totalClient}<br/>
                           <small>Cost per client: {costPerClient}</small>
                           </h5>
                         </div>
                         <div className="align-self-center">
                           <img src={cost_pl_img} alt="performance PNG" width='50px'/>
                         </div>
                       </div>
                     </CardBody>
                   </Card>
             
           </Col>
          

          
         </Row>
                </Col>


            
             </Row>
            
            
              
           
          </Container>
        </div>
      </React.Fragment>
    )
  }


}

ProjectBuilderDetail.propTypes = {
  t: PropTypes.any,
  history:PropTypes.object,
  projectData: PropTypes.object,
  match: PropTypes.object,
  onGetProjectUUIDAction: PropTypes.func,
  loading:PropTypes.object
}

//

const mapStateToProps = ({ Project  }) => ({
  projectData: Project.projectData,
  loading:Project.loading
});

const mapDispatchToProps = dispatch => ({
  onGetProjectUUIDAction: id => dispatch(getProjectUUIDAction(id)),
});



export default connect(mapStateToProps, mapDispatchToProps)(withRouter(withTranslation()(ProjectBuilderDetail)))